/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import React from 'react';
// Components
import PageHero from '../components/pageHero/pageHero';
import { labels } from '@umati/dashboard-common';
import DOMPurify from 'dompurify';
import ENVs from '../utilities/ENVs';

function DataPolicy() {
  return (
    <div className="view-textpage">
      <PageHero title={labels.dataPolicy} />
      <div className="container" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(ENVs.PolicyHTML()) }} />
    </div>
  );
}

export default DataPolicy;
